import "./index.css";
import { useEffect } from "react";
import World from "./components/World";
import ProjectStats from "./components/ProjectStats";
import useStore from "./modules/useStore";
import NavHeader from "./components/NavHeader";
import prismic from "./modules/prismic";
import { RichText } from "prismic-reactjs";
import IntroShow from "./components/IntroShow";
import AboutMe from "./components/AboutMe";

function makeProject({ data, id, tags }) {
  return {
    id,
    tags,
    title: data.title,
    client: data.client,
    year: data.year,
    description: RichText.asText(data.description),
    video: data.video,
    link: data.link,
  };
}

function App() {
  const { onProjects, setProjects } = useStore((state) => ({
    onProjects: state.onProjects,
    setProjects: state.setProjects,
  }));

  useEffect(() => {
    const fetchData = async () => {
      const response = await prismic.query("");
      console.log(response);
      if (response) {
        setProjects(
          response.results.filter((d) => d.type === "project").map(makeProject)
        );
      }
    };
    fetchData();
  }, [setProjects]);
  return (
    <div className="h-screen">
      <World />
      {onProjects ? 
      <>
        <NavHeader />
        <ProjectStats />
      </> : <AboutMe />}
    </div>
  );
}

export default App;
